import React from "react";
import { ControlLabel, Button, Alert } from "react-bootstrap";
import DatePicker from "react-bootstrap-date-picker";
import ReportsParameterSortBy from "./reports-parameter-sortby.jsx"; 
import ReportsParameterCompany from "./reports-parameter-company.jsx";
import ReportsViewer from "./reports-viewer.jsx";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import Iframe from 'react-iframe';
import moment from "moment";

export default class ReportsUnapprovedHours extends React.Component {
    constructor(props) {
        super(props);
        var dateToday = new Date().toISOString();

        this.state = {
            fromDate: dateToday,
            toDate: dateToday,
            sortBy: "approver",
            errors: [],
            fromDateValue: "",
            toDateValue: "",
            company: "",
            pdfUrl: ''
        }

        this.onRunReport = this.onRunReport.bind(this);
        this.handleFromDateChange = this.handleFromDateChange.bind(this);
        this.handleToDateChange = this.handleToDateChange.bind(this);
        this.handleSortByChange = this.handleSortByChange.bind(this);
        this.handleCompanyChange = this.handleCompanyChange.bind(this);
        this.runReport = this.runReport.bind(this);
        this.loadReportViewModel = this.loadReportViewModel.bind(this);
        this.isAndroid = this.isAndroid.bind(this);
        this.isIos = this.isIos.bind(this);

        this.loadReportViewModel();
    }

    componentDidMount() {
        this.setState({
            fromDateValue: this.getFormattedDate("fromdate-datepicker"),
            toDateValue: this.getFormattedDate("todate-datepicker")
        });
    }

    loadReportViewModel() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get(this.props.role + "/reports-unapproved-hours")
            .then(function (res) {
                self.setState({
                    reportCode: res.data.reportCode,
                    keys: res.data.keys,
                    connection: res.data.connection,
                    role: res.data.role,
                    id: res.data.id,
                    username: res.data.username,
                    startDateLabel: res.data.startDateLabel,
                    endDateLabel: res.data.endDateLabel,
                    sortByLabel: res.data.sortByLabel,
                    runReportLabel: res.data.runReportLabel,
                    companyLabel: res.data.companyLabel,
                    requiredLabel: res.data.requiredLabel,
                    invalidStartDateLabel: res.data.invalidStartDateLabel,
                    invalidEndDateLabel: res.data.invalidEndDateLabel,
                    invalidDateRangeLabel: res.data.invalidDateRangeLabel
                });

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onRunReport() {
        var messages = this.validate();
        this.setState({
            errors: messages
        });

        if (messages.length == 0) {
            this.runReport();
        }
    }

    runReport() {
        let self = this;
        var values =
            self.state.connection + "|" +
            self.state.fromDateValue + "|" +
            self.state.toDateValue + "|" +
            self.state.sortBy + "|" +
            self.state.id + "|" +
            self.state.role.replace('-', '') + "|" +
            self.state.username + "|" +
            self.state.company;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        var params = {
            ReportCode: self.state.reportCode,
            Keys: self.state.keys,
            Values: values
        };

        var isAndroid = this.isAndroid();
        var isIos = this.isIos();

        // Open only for desktop
        if (isAndroid == false && isIos == false) {
            var myWindow = window.open("", "_blank");
            myWindow.document.write("<div id='divLoadMessage'>Please wait while report is loading...</div>");
        }

        ajax.api().put(`save-report`, params)
            .then(function (res) {
                if (isAndroid || isIos) {
                    self.setState({
                        pdfUrl: res.data.filePath
                    });
                    setTimeout(function() {
                        document.getElementById('aMobileOpener').click();
                    }, 10);
                } else {
                    myWindow.document.write("<script type='text/javascript'>document.getElementById('divLoadMessage').style.display = 'none';</script>");
                    myWindow.document.write("<iframe src='" + res.data.filePath + "' style='width: 100%; height: 100%;'></iframe>");
                }
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
                if (isAndroid == false && isIos == false) {
                    myWindow.close();
                }
            }); 
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    validate() {
        let msg = [];

        var startDate = this.getFormattedDate("fromdate-datepicker");
        if (startDate.length == 0) {
            msg.push(this.state.invalidStartDateLabel);
            this.setState({
                fromDate: null
            });
        }

        var endDate = this.getFormattedDate("todate-datepicker");
        if (endDate.length == 0) {
            msg.push(this.state.invalidEndDateLabel);
            this.setState({
                toDate: null
            });
        }

        if (startDate.length > 0 && endDate.length > 0) {
            if ((new Date(startDate)) > new Date(endDate)) {
                msg.push(this.state.invalidDateRangeLabel);
            }
        }

        return msg;
    }

    getFormattedDate(id) {
        //return document.getElementById(id).getAttribute("data-formattedvalue").trim(); // accessed value from dom because handle change isn't fired when removed
        return moment(document.getElementById(id).getAttribute("value").trim()).format("MM/DD/YYYY");
    }

    handleSortByChange(sortByValue) {
        this.setState({
            sortBy: sortByValue
        });
    }

    handleFromDateChange(value, formattedValue) {
        this.setState({
            fromDate: value,
            fromDateValue: moment(value).format("MM/DD/YYYY")
        });
    }

    handleToDateChange(value, formattedValue) {
        this.setState({
            toDate: value,
            toDateValue: moment(value).format("MM/DD/YYYY")
        });
    }

    handleCompanyChange(value) {
        this.setState({
            company: value
        });
    }

    render() {
        var rowStyle = {
            "padding-top": "10px"
        };

        var requiredStyle = {
            "color": "red"
        };

        var displayNone = {
            "display": "none"
        };

        let company = null;
        if (this.props.role == 'payroll-admin') {
            company = 
                <div className="col-md-6 col-lg-6">
                    <div className="col-md-12 col-lg-12">
                        <ControlLabel className="ap-report-control-label">{this.state.companyLabel}:</ControlLabel>
                    </div>
                    <div className="col-md-12 col-lg-12">
                        <ReportsParameterCompany onChange={this.handleCompanyChange} />
                    </div>
                </div>;
        }
        else {
            company = <div></div>;
        }

        return (
            <div className="container-fluid">
                <a id="aMobileOpener" href={this.state.pdfUrl} style={displayNone}></a>
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <div className="col-md-12 col-lg-12">
                            <ControlLabel className="ap-report-control-label"><i className="fa fa-caret-right" style={requiredStyle}></i>-{this.state.requiredLabel}</ControlLabel>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <ControlLabel className="ap-report-control-label">{this.state.startDateLabel}: <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <DatePicker id="fromdate-datepicker" placeholder="MM/DD/YYYY" value={this.state.fromDate}
                                onChange={this.handleFromDateChange}
                                onInput={this.handleFromDateChange} />
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <ControlLabel className="ap-report-control-label">{this.state.endDateLabel}: <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <DatePicker id="todate-datepicker" placeholder="MM/DD/YYYY" value={this.state.toDate}
                                onChange={this.handleToDateChange}
                                onInput={this.handleToDateChange} />
                        </div>
                    </div>
                </div>
                <div className="row" style={rowStyle}>
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <ControlLabel className="ap-report-control-label">{this.state.sortByLabel}:</ControlLabel>
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <ReportsParameterSortBy onChange={this.handleSortByChange} />
                        </div>
                    </div>
                    {company}
                </div>
                <div className="row">
                    <div className="col-md-6 col-lg-6">
                        <div className="col-md-12 col-lg-12">
                            <Button onClick={this.onRunReport} className="btn-info ap-fullsize">{this.state.runReportLabel}</Button>
                        </div>
                    </div>
                </div>
                <div className="row" style={rowStyle}>
                    <div className="col-md-12 col-lg-12">
                        <div className="col-md-12 col-lg-12">
                            <Alert bsStyle="danger" className={this.state.errors.length > 0 ? "" : "ap-hidden"}>
                                <ul>
                                    {this.state.errors.map(m =>
                                        <li key={m}>{m}</li>)}
                                </ul>
                            </Alert>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}